{
  "version": 1,
  "asset_id": "44fc140c-33e7-4e44-b63a-0e286f4e514a",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/44fc140c-33e7-4e44-b63a-0e286f4e514a/sleeve-hiatal-type-1-600.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/44fc140c-33e7-4e44-b63a-0e286f4e514a/sleeve-hiatal-type-1-600.jpg",
  "original_filename": "sleeve-hiatal-type-1-600.jpg",
  "size": 78114,
  "content_type": "image/jpeg",
  "created_at": "2026-09-26T21:30:21Z"
}
